// aiAssessment组件翻译
export default {
  // AI助手文案
  assistant: {
    title: "我是图链智能助手小图",
    description:
      "我融合了大模型和北鸣科技丰富的研判经验，辅助您对地址进行研判分析以及解答您关于虚拟币的任何问题。",
  },

  // 占位符文本
  placeholder:
    '请输入一个有效的区块链地址以便帮助您对其进行分析\n您可以尝试这样提问，如: "帮我对TWpMnUh9pZS1Mf8yyy9WPiS82WYevKzQo2地址在Tron链上主币的交易数据进行综合分析"',

  // 工具提示
  tooltips: {
    historicalRecords: "对话记录",
  },

  // 示例卡片
  examples: {
    example1: "分析Tron上的USDT流出情况，地址是TFP...z7f",
    example2: "对TWpM...Qo2进行综合分析",
    fullExample1:
      "分析Tron上的USDT流出情况，地址是TFPgHWmveJ8CA4cyKXFq2mik8AbQemuz7f",
    fullExample2: "对TWpMnUh9pZS1Mf8yyw9WPiS82WYevKzQo2进行综合分析",
  },
};
